import { getPathArea } from './get-path-area';
export function getDrawDirection(pathArray) {
    return getPathArea(pathArray) >= 0;
}
//# sourceMappingURL=get-draw-direction.js.map